<template>
  <div style="width: 100%">
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center flex-grow-1"
      style="height: 500px"
    >
      <v-progress-circular indeterminate color="primary" size="60">
      </v-progress-circular>
    </div>

    <l-map
      ref="map"
      v-else
      class="map_style"
      style="width: 100%; z-index: 0"
      :zoom="zoom"
      :center="[location.latitude, location.longitude]"
      :options="{ zoomControl: false }"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
        :detectRetina="true"
      ></l-tile-layer>
      <l-control-zoom position="topright"></l-control-zoom>

      <custom-marker
        :marker="{ lat: location.latitude, lng: location.longitude }"
      >
        <v-icon color="secondary" class="rounded-circle pulse-button" size="15"
          >mdi-circle</v-icon
        >
      </custom-marker>
    </l-map>
  </div>
</template>

<script>
import axios from "axios";
import { LMap, LTileLayer, LControlZoom } from "vue2-leaflet";
import CustomMarker from "vue-leaflet-custom-marker";

import { Icon } from "leaflet";

import { mapActions, mapState } from "vuex";

// Icon fix
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  components: {
    LMap,
    LTileLayer,
    CustomMarker,
    LControlZoom,
  },

  async created() {
    try {
      this.loader = true;
      await this.getLocation();
      console.log(this.location);

      this.loader = false;
    } catch (e) {
      console.log(e);
    }
  },

  mounted() {},

  data() {
    return {
      pois: [],
      map: null,

      loader: true,

      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 12,

      dialog: {
        open: false,
        poi: null,
      },
    };
  },

  computed: {
    ...mapState({
      location: (state) => state.base.location,
    }),
  },

  methods: {
    ...mapActions(["getLocation"]),
  },
};
</script>

<style scoped lang='scss'>
.pulse-button {
  -webkit-animation: pulse-location 1.5s infinite;
  box-shadow: 0 0 0 8px rgba(#5a99d4, 0.5);
  border: 0.5px solid white;
}

.pulse-button:hover {
  -webkit-animation: none;
}
</style>